import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function createImprovementProposalMeeting(proposalId, data) {
  if (!proposalId) return false;
  try {
    await getAPIResponse(`/v1/improvement-proposal/${proposalId}/meeting`, {
      meetingDate: data.meetingDate,
      recurrenceDays: parseInt(data.recurrenceDays || 0, 10),
      description: data.description || ''
    }, 'POST');
    return true;
  } catch (e) {
    return false;
  }
}
